import React, { useEffect } from "react";
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import styles from './user.module.css';
import { SET_PATH_PARAMS } from "../../services/actions/path_params_actions";
import { postActivation } from "../../utils/api";
import { useDispatch, useSelector } from "react-redux";
import { SET_PORTAL_API } from "../../services/actions/portal_actions";
import { TITLE_ERROR, TITLE_NOTIFICATION, TEXT_ACTIVATION_SUCCESS } from "../../utils/constants";
import { START_LOADING, END_LOADING } from "../../services/actions/loading_actions";
import { getDataFromRoutes, setMetaTags } from "../../utils/util_functions";
import Loader from "../../components/loader/loader";
import { getLoading } from "../../services/selectors";
import { ROUTES_CONST } from "../../utils/constants";


const Activation = () => {

  const { uid, token } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();

  useEffect(() => {
    dispatch({
      type: SET_PATH_PARAMS,
      uid,
      token,
      slug1: '',
      slug2: '',
      slug3: '',
      slug4: ''
    });
    // eslint-disable-next-line
  }, [location]);

  const isLoading = useSelector(getLoading);

  const {
    title, metaTitle, metaDescription, metaKeywords, metaRobots
  } = getDataFromRoutes(location.pathname, ROUTES_CONST, uid, token);

  useEffect(() => {
    setMetaTags(metaTitle, metaDescription, metaKeywords, metaRobots);
    // eslint-disable-next-line
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch({ type: START_LOADING });
    postActivation(uid, token)
      .then(() => {
        navigate('/login', { replace: true });
        dispatch({
          type: SET_PORTAL_API,
          title: TITLE_NOTIFICATION,
          text: TEXT_ACTIVATION_SUCCESS
        });
      })
      .catch(error => {
        console.log('error =', error);
        dispatch({
          type: SET_PORTAL_API,
          title: TITLE_ERROR,
          text: Object.values(error)
        });
        navigate('/', { replace: true });
      })
      .finally(() => {
        dispatch({ type: END_LOADING });
      });
  }

  return (
    <main className='main'>
      {isLoading ? <Loader /> : null}
      <h1 className="title title__left">{title}</h1>
      <div className={styles.box}>
        <form onSubmit={handleSubmit} className="form">
          <button type="submit" className='button'>
            Активировать
          </button>
        </form>
        <div className={styles.aside_block}>
          <p className="text__gray">
            После активации учётной записи вы можете воспользоваться личным кабинетом
          </p>
        </div>
      </div>
    </main>
  )
}

export default Activation;
